export default {
  FAQS: 'faqs',
  DOCS: 'docs',
  GUIDES: 'guides',
  UPDATES: 'updates',
  MODERN_BLOG: 'modern_blog'
}
